import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface SectionTitleProps {
  /** Give the id to the enclosing region's aria-labelledby. */
  id?: string | undefined
  children: ReactNode
  className?: string
}

/**
 * The `section` level (Newsreader 22), only on screens with more than one region: Beranda,
 * Sinkronisasi, Administrasi, Pengaturan. 40 px above (the xl step between regions), 16 px
 * below. No pigment-tick: the DNA places the signature before the page title only (and
 * beside a save), so a screen of seven regions still shows one red tick, not eight.
 */
export function SectionTitle({ id, children, className }: SectionTitleProps) {
  return (
    <h2 id={id} className={cn('mt-10 mb-4 font-display text-section text-text', className)}>
      {children}
    </h2>
  )
}
